import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { FileQuestion, Home } from 'lucide-react';

/**
 * 404 Not Found page
 */
export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="not-found-page">
      <div className="max-w-md w-full mx-auto text-center space-y-6 p-6">
        <div className="flex justify-center">
          <div className="rounded-full bg-muted p-3">
            <FileQuestion className="h-8 w-8 text-muted-foreground" />
          </div>
        </div>
        
        <div className="space-y-2">
          <h1 className="text-2xl font-bold tracking-tight">
            {t('errors.notFound.title', 'Page Not Found')}
          </h1>
          <p className="text-muted-foreground">
            {t('errors.notFound.description', 
              'The page you\'re looking for doesn\'t exist or has been moved.'
            )}
          </p>
        </div>

        <Button onClick={handleGoHome} className="flex items-center gap-2">
          <Home className="h-4 w-4" />
          {t('common.goHome', 'Go to Dashboard')}
        </Button>
      </div>
    </div>
  );
};